import Vue from 'vue'

export {
  login
}

const API_AUTH_LOGIN = '/api/wx/get_wechat_token'  // 直接调用main下的微信认证

function login (code, success = null, failed = null) {
  Vue.http.get(API_AUTH_LOGIN, {params: {code}})
    .then((resp) => {
      if (success) success(resp)
    })
    .catch((error) => {
      if (failed) failed(error)
    })
}



// WEBPACK FOOTER //
// ./src/api/auth/wx-login.js